const montaGraficoEvolucao = (dados) =>  {
  let anos = [];
  let valor = [];
  dados.forEach((el) => {
    anos.push(el.DT_MOVTO)
    valor.push(el.VL_MOVTO)
  });
  return {
    series: [{
      data: valor
    }],
      chart:{
        chart: {
          toolbar: {
            show: false,
          }
        },
        plotOptions: {
          bar: {
            barHeight: '75%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        colors: ['#556ee6', '#34c38f', '#50a5f1', '#f1b44c', '#f1b44c', '#f46a6a', '#74788d',],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          formatter: function (val) {
              return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
          },
        },
        xaxis: {
          categories: anos,
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: true
          },
          y: {
            title: {
              formatter: function () {
                return ''
              }
            },
            formatter: function (val) {
              return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
            },
          }
        },
        legend: {
          show: false,
        }
      }
  }
};

export { montaGraficoEvolucao };


